__turbopack_context__.v({
  "className": "caveat_4406bcee-module__wm6C3W__className",
});
